module.exports = __webpack_public_path__ + "img/1.76911e89.jpg";